<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span>Boletos</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">POSIÇÃO EM ABERTO</h3>
          </div>
        </div>
        <div class="row">          
          <div class="col-md-12">                      
            <div class="row">
              <div class="col-xs-12">
                <vue-good-table
                  :columns="columns"
                  :rows="registros"
                  :pagination-options="{
                          enabled: true,
                          mode: 'records',
                          perPage: 20,
                          position: 'top',
                          perPageDropdown: [20, 40, 60],
                          dropdownAllowAll: true,
                          nextLabel: 'Próximo',
                          prevLabel: 'Anterior',
                          rowsPerPageLabel: 'Linhas por página',
                          ofLabel: 'de',
                          pageLabel: 'page',
                          allLabel: 'Todos',
                        }"
                  styleClass="vgt-table"
                >
                  <template slot="table-row" slot-scope="props">
                    <span
                      v-if="props.column.field == 'valor' || props.column.field == 'credito' || props.column.field == 'pago'"
                    >{{formatCurrency(props.formattedRow[props.column.field])}}</span>
                    <span
                      v-else-if="props.column.field == 'nrPedido' && permissions.isFinancial"                    
                    >{{props.formattedRow[props.column.field]}}</span>

                    <!-- <a
                      href="#"
                      v-else-if="props.column.field == 'nrDocumento'"
                      data-toggle="modal" data-target="#default-modal"
                      @click.prevent="showModal=true"
                    >{{props.formattedRow[props.column.field]}}</a> -->

                    <a
                      target="_blank"
                      v-else-if="props.column.field == 'nrDocumento'"
                        :href="`${$SiteUrl}/${props.row.url}`"
                    >{{props.formattedRow[props.column.field]}}</a>
                    <span v-else>{{props.formattedRow[props.column.field]}}</span>
                  </template>
                  <div slot="emptystate">Sem dados para exibição</div>
                </vue-good-table>
                <div class="panel panel-default">
                  <div class="panel-heading" style="text-align: end; font-weight: bold">Total: {{ soma }}</div>
                </div>
                <modal-default title="Boleto" width="90" v-if="showModal" @close="showModal = false"></modal-default>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

import "vue-good-table/dist/vue-good-table.css";

import { VueGoodTable } from "vue-good-table";
import ModalDefault from "./partials/ModalDefault.vue";

export default {
  name: "TicketPayment",
  components: {
    VueGoodTable,
    ModalDefault
  },
  data() {
    return {
      showModal: false,
      permissions: {
        isFinancial: true
      },
      columns: [
        { label: "Documento", field: "nrDocumento" },
        { label: "Pedido", field: "nrPedido" },
        { label: "Emissão", field: "data" },
        { label: "Vencimento", field: "dataVencimento" },
        { label: "Valor", field: "valor" },
        { label: "Crédito", field: "credito" },
        { label: "Pago", field: "pago" },
        { label: "Banco", field: "banco" }
      ],
      registros: [],
      soma: 0
    };
  },
  mounted(){
    const self = this
    var xhr = new XMLHttpRequest();
    xhr.onload = () => {
      if (xhr.status == 200)
      {
        let jsonResponse = JSON.parse(xhr.responseText);
        jsonResponse.forEach((element) => {
          let registro = {};
          registro.nossoNumero = element.NossoNumero;
          registro.nrDocumento = element.Documento;
          registro.nrPedido = element.Pedido;
          registro.data = element.DataEmissao.replace("00:00:00", '');
          registro.dataVencimento = element.DataVencimento.replace("00:00:00", '')
          registro.valor = element.ValorParcela;
          registro.pago = element.ValorPago;
          registro.credito = element.ValorCredito;
          registro.banco = element.Banco;

          registro.url = '';
          if (registro.banco == 'DUPLICATA A VISTA')
          {
            registro.url = 'Financeiro/duplicatavista/' + element.NossoNumero;
          }
          else
          {
            registro.url= 'Financeiro/duplicata/' + element.NotaFiscal + '/' + element.Serie + '/' + element.Parcela;
          }

          registro.cli_codigo = element.Cliente;
          registro.crc_cupomnf = element.NotaFiscal;
          registro.crc_serienf = element.Serie;
          registro.crr_parcela = element.Parcela;
          let valorDouble = registro.valor.replace(',', '.')
          this.soma += parseFloat(valorDouble);
          this.registros.push(registro);
        })

        this.soma = this.formatCurrency(this.soma)
      }
      else if (xhr.status == 401){
          swal({
            title: "É necessário estar logado",
            icon: "warning"
          }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
      }
    };

    xhr.open("GET", this.$apiUrl + "Financeiro.svc/retornaboletos");
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.withCredentials = true;
    xhr.send();
  },
  methods: {
    formatCurrency: function(v) {
      //formada coluna de valores da tabela para moeda
      v = v.toString().replace(',','.')
      var formato = {
        minimumFractionDigits: 2,
        style: "currency",
        currency: "BRL"
      };
      return parseFloat(v).toLocaleString("pt-BR", formato);
    }
  }
};
</script>
